import { render, staticRenderFns } from "./d-scrollable-content.vue?vue&type=template&id=3f408fcf&scoped=true&"
import script from "./d-scrollable-content.vue?vue&type=script&lang=js&"
export * from "./d-scrollable-content.vue?vue&type=script&lang=js&"
import style0 from "./d-scrollable-content.vue?vue&type=style&index=0&id=3f408fcf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f408fcf",
  null
  
)

export default component.exports